import React from "react";

const WaysToEarnItem = ({
  imgUrl,
  title,
  desc,
  isButton = false,
  disabled = true,
  buttonText = "Redeem",
  onClickHandler,
  note = "",
}) => {
  return (
    <div onClick={onClickHandler} className="waysToEarn-item-container">
      <div className="waysToEarn-item-image-container">
        <img src={imgUrl} alt="icon" />
      </div>
      <div className="waysToEarn-item-text-container">
        <p className="waysToEarn-item-text">{title}</p>

        <p
          style={{
            fontSize: "10px",
            paddingInline: "2px",
            textAlign: "center",
            minHeight: "14px",
          }}
        >
          {note ? `(*${note})` : ""}
        </p>
      </div>
      <div className="waysToEarn-item-details-container">
        <span className="waysToEarn-item-details">{desc}</span>

        <button
          style={{
            visibility:
              !isButton || buttonText?.length === 0 ? "hidden" : "visible",
          }}
          disabled={disabled}
          onClick={onClickHandler}
          className="waysToEarn-item-button"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default WaysToEarnItem;
